
import { mapState } from 'vuex';
import { hydrateWhenIdle, hydrateWhenVisible } from 'nuxt-lazy-hydration';

export default {
  name: 'Block',

  components: {
    cards: hydrateWhenVisible(() => import(`@/components/blocks/cards.vue`)),
    contentPanel: hydrateWhenVisible(() =>
      import(`@/components/blocks/contentPanel.vue`)
    ),
    ctaSmall: hydrateWhenVisible(() =>
      import(`@/components/blocks/ctaSmall.vue`)
    ),
    customBlock: hydrateWhenVisible(() =>
      import(`@/components/blocks/customBlock.vue`)
    ),
    faq: hydrateWhenVisible(() => import(`@/components/blocks/faq.vue`)),
    gallery: hydrateWhenVisible(() =>
      import(`@/components/blocks/gallery.vue`)
    ),
    hero: hydrateWhenIdle(() => import(`@/components/blocks/hero.vue`)),
    heroAlt: hydrateWhenIdle(() => import(`@/components/blocks/heroAlt.vue`)),
    imageAndText: hydrateWhenIdle(() =>
      import(`@/components/blocks/imageAndText.vue`)
    ),
    links: hydrateWhenVisible(() => import(`@/components/blocks/links.vue`)),
    list: hydrateWhenVisible(() => import(`@/components/blocks/list.vue`)),
    layoutLogos: hydrateWhenVisible(() =>
      import(`@/components/blocks/logotypes.vue`)
    ),
    news: hydrateWhenVisible(() => import(`@/components/blocks/news.vue`)),
    newsletter: hydrateWhenVisible(() =>
      import(`@/components/blocks/newsletter.vue`)
    ),
    productSlider: hydrateWhenVisible(() =>
      import(`@/components/blocks/productSlider.vue`)
    ),
    promo: hydrateWhenVisible(() => import(`@/components/blocks/promo.vue`)),
    quoteBlock: hydrateWhenVisible(() =>
      import(`@/components/blocks/quoteBlock.vue`)
    ),
    slider: hydrateWhenVisible(() => import(`@/components/blocks/slider.vue`)),
    testimonials: hydrateWhenVisible(() =>
      import(`@/components/blocks/testimonials.vue`)
    ),
    videoBlock: hydrateWhenVisible(() =>
      import(`@/components/blocks/videoBlock.vue`)
    ),
    texteditor: hydrateWhenVisible(() =>
      import(`@/components/blocks/texteditor.vue`)
    ),
    imageblock: hydrateWhenVisible(() =>
      import(`@/components/blocks/imageblock.vue`)
    ),
    slidingtext: hydrateWhenVisible(() =>
      import(`@/components/blocks/slidingText.vue`)
    ),
    bullets: hydrateWhenVisible(() =>
      import(`@/components/blocks/bullets.vue`)
    ),
  },

  props: {
    block: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    animate: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(['options']),

    layout() {
      return this.block && this.block.acf_fc_layout
        ? this.block.acf_fc_layout
        : '';
    },

    component() {
      const hasRegistered =
        this.layout &&
        this.$options.components &&
        this.$options.components[this.layout];
      return hasRegistered ? this.layout : 'div';
    },

    className() {
      return this.layout ? `block_${this.layout}` : 'block';
    },

    sharedblocks() {
      return this.options.blocks;
    },

    blockData() {
      if (this.block && this.block.content === 'shared') {
        const filtered = this.sharedblocks.filter(
          (b) => (b && b.acf_fc_layout) === this.layout
        );
        const index = Number(this.block.content_option) || 0;
        if (filtered.length > index && filtered[index]) {
          return filtered[index];
        }
        return this.block;
      }
      return this.block;
    },
  },
};
